var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Select } from '@folio/stripes/components';
import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { ComparisonOperator } from '../../types';
export default function OperatorSelect(_a) {
    var name = _a.name;
    var intl = useIntl();
    return (React.createElement(Field, { name: name }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { fullWidth: true, marginBottom0: true, required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.aggregate.filter.operator" }), dataOptions: [
            { label: '', value: undefined },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.aggregate.filter.operator.less',
                }),
                value: ComparisonOperator.LESS_THAN,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.aggregate.filter.operator.lessEqual',
                }),
                value: ComparisonOperator.LESS_THAN_EQUAL,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.aggregate.filter.operator.greater',
                }),
                value: ComparisonOperator.GREATER_THAN,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.aggregate.filter.operator.greaterEqual',
                }),
                value: ComparisonOperator.GREATER_THAN_EQUAL,
            },
        ] }))); }));
}
